'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
}; //# sourceMappingURL=ColorScheme.js.map